export default __webpack_public_path__ + "static/media/Background1.8b646c60.jpeg";